import React, { Component } from 'react'
import Match from '../containers/Match'
import Auth from '../containers/Auth'
// import AIChat from './AIChat/AIChat'
import AuthenticationHelper from '../../helpers/AuthenticationHelper'
import matchConfig from '../../config/matchConfig'

class Main extends Component {
    
    constructor(props)
    {
        super(props)
    }

    async componentDidMount()
    {
        // console.log(`main component mounted`)
        const loggedIn = await AuthenticationHelper.hasAuthenticated()
        if(!loggedIn) this.props.switchPage(matchConfig.pages.login)

        // console.log(AuthenticationHelper.uuid)
        // console.log(AuthenticationHelper.token)
    }

    render()
    {
        //console.log(this.props)

    // Relax gating: allow app to render even if profile.uuid isn't populated yet.
    // Only gate by authentication token presence.
    if(!AuthenticationHelper.hasAuthenticated()) return <Auth />

        switch(this.props.page)
        {
            case matchConfig.pages.profile:
            case matchConfig.pages.story:
            case matchConfig.pages.chat:
                return <Match />
            // case matchConfig.pages.aichat: this not used anymore //first trial
            //     return <AIChat />
            case matchConfig.pages.login:
            case matchConfig.pages.register:
            case matchConfig.pages.forgotPass:
            default:
                return <Auth />
        }
    }
}

export default Main